import sum from 'lodash/sum';
import {ELECTRIC_MAINTENANCE_COST_FACTOR} from '@generic/data/assumptions';

const calcPerMileElectricityMaintenanceCosts = ({vehicleSets}) =>
  sum(
    vehicleSets.map((set) => set.vehicle.maintenanceCostPerMile * ELECTRIC_MAINTENANCE_COST_FACTOR)
  );

export default calcPerMileElectricityMaintenanceCosts;
